// components/Toolbar/tools/SelectTool.js
import React, { useEffect, useState } from 'react';
import HandIcon from '../../images/Icon20_Pan.svg';
import Button from '../Toolbar/Button';
import { connect } from 'react-redux';
import {
  setCursorTooltip,
  updateTool,
} from '../../../../redux/actions/fabric_overlay';
import InfoBox from './InfoBox';
import { __, setTableParams } from '../../../../core/utils';

const Hand = ({
  fabric_overlay: { activeTool, viewer, fabricOverlay },
  plan,
  isActive,
}) => {
  const [infoBox, setInfoBox] = useState(null); // 👈 lokalni state za info

  const handleClick = () => {
    viewer.setMouseNavEnabled(true);
    updateTool({ tool: 'hand' });
  };

  const _handleReadTask = (taskID) => {
    setTableParams('all_tasks', {
      clicked_row: taskID,
    });
  };

  useEffect(() => {
    if (!fabricOverlay || activeTool != 'hand') return;

    const canvas = fabricOverlay.fabricCanvas();

    canvas.selection = false;

    setCursorTooltip('');

    canvas.forEachObject((obj) => {
      obj.selectable = false;
      obj.evented = true;

      obj.setCoords();
    });

    canvas.requestRenderAll();

    canvas.defaultCursor = 'default';
    canvas.hoverCursor = 'pointer';
    canvas.moveCursor = 'grabbing';

    function handleMouseDown(obj, e) {
      if (!obj || !obj.objectType || obj.objectType === 'task') {
        viewer.setMouseNavEnabled(true);

        return setInfoBox(null);
      }

      setInfoBox({
        object: obj,
        position: {
          left: e.clientX - 25,
          top: e.clientY + 20,
        },
      });

      setCursorTooltip('');

      viewer.setMouseNavEnabled(true);
    }

    function handleMouseOver(e) {
      const obj = e.target;

      if (!obj) return;

      setCursorTooltip(__('canvas.tooltip.hand'));
    }

    function handleMouseOut(e) {
      setCursorTooltip('');
    }

    const onPointerDown = (e) => {
      const target = canvas.findTarget(e);

      if (target?.objectType === 'task') {
        return _handleReadTask(target.taskID);
      }

      handleMouseDown(target, e);

      // viewer.setMouseNavEnabled(false)
      // if (e.pointerType === 'touch') {
      //   if (e.touches && e.touches.length == 2) {
      //     handleMouseDown({ e });
      //   } else if (e.touches && e.touches.length >= 2) {
      //     handleMouseDown({ e });
      //   }
      // } else {
      //   viewer.setMouseNavEnabled(false);
      // }
    };

    canvas.on('mouse:over', handleMouseOver);
    canvas.on('mouse:out', handleMouseOut);
    canvas.upperCanvasEl.addEventListener('pointerdown', onPointerDown);

    return () => {
      canvas.off('mouse:over', handleMouseOver);
      canvas.off('mouse:out', handleMouseOut);
      canvas.upperCanvasEl.removeEventListener('pointerdown', onPointerDown);

      setInfoBox(null);
    };
  }, [fabricOverlay, activeTool]);

  const handleCloseInfo = () => setInfoBox(null);

  return (
    <>
      <Button
        id='hand'
        label={__('canvas.toolbar.hand')}
        icon={HandIcon}
        active={activeTool === 'hand'}
        onClick={handleClick}
        extraClass={['roundedUp']}
      />

      {infoBox && (
        <InfoBox infoBox={infoBox} onClose={handleCloseInfo} plan={plan} />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    fabric_overlay: state.fabric_overlay,
  };
};

export default connect(mapStateToProps, null)(Hand);
